






import {Component, Vue} from 'vue-property-decorator';
import HeaderButtons from './HeaderButtons.vue';

@Component({
    components: {HeaderButtons},
})

export default class HeaderCOMUNE extends Vue {}
